
import { useEffect, useRef, useState } from "react";

export const GoogleSignInButton = ({ testId }) => {
  const buttonRef = useRef(null);
  const [error, setError] = useState("");

  useEffect(() => {
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

    if (!clientId) {
      console.error(
        "Missing REACT_APP_GOOGLE_CLIENT_ID"
      );
      setError("Google Sign-In is not configured.");
      return;
    }

    const renderGoogleButton = () => {
      if (
        !window.google ||
        !window.google.accounts ||
        !window.google.accounts.id
      ) {
        console.error(
          "Google Identity Services is not available."
        );
        setError("Google Sign-In could not load.");
        return;
      }

      if (!buttonRef.current) {
        return;
      }

      window.google.accounts.id.initialize({
        client_id: clientId,

        callback: async (response) => {
          try {
            console.log(
              "Google credential received"
            );

            const res = await fetch(
              "/api/auth/google/session",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  idToken: response.credential,
                }),
              }
            );

            const data = await res.json();

            if (!res.ok) {
              throw new Error(
                data.detail ||
                  "Google sign-in failed"
              );
            }

            localStorage.setItem(
              "token",
              data.token
            );

            window.dispatchEvent(
              new Event("auth-change")
            );

            window.location.href = "/";
          } catch (err) {
            console.error(
              "Google authentication failed:",
              err
            );

            setError(
              err.message ||
                "Google sign-in failed."
            );
          }
        },
      });

      buttonRef.current.innerHTML = "";

      window.google.accounts.id.renderButton(
        buttonRef.current,
        {
          theme: "outline",
          size: "large",
          text: "continue_with",
          shape: "pill",
          width: 400,
        }
      );

      console.log(
        "Google Sign-In button rendered"
      );
    };

    const existingScript = document.querySelector(
      'script[src="https://accounts.google.com/gsi/client"]'
    );

    if (existingScript) {
      if (window.google?.accounts?.id) {
        renderGoogleButton();
      } else {
        existingScript.addEventListener(
          "load",
          renderGoogleButton
        );
      }

      return;
    }

    const script =
      document.createElement("script");

    script.src =
      "https://accounts.google.com/gsi/client";

    script.async = true;
    script.defer = true;

    script.onload = renderGoogleButton;

    script.onerror = () => {
      console.error(
        "Could not load Google Identity Services"
      );

      setError(
        "Could not load Google Sign-In."
      );
    };

    document.head.appendChild(script);

    return () => {
      script.onload = null;
    };
  }, []);

  return (
    <>
      <div className="my-5 flex items-center gap-3">
        <div className="h-px flex-1 bg-border" />

        <span className="text-xs uppercase tracking-wide text-muted-foreground">
          or
        </span>

        <div className="h-px flex-1 bg-border" />
      </div>

      <div
        ref={buttonRef}
        data-testid={testId}
        className="flex w-full justify-center"
      />

      {error && (
        <p className="mt-2 text-center text-sm text-red-500">
          {error}
        </p>
      )}
    </>
  );
};